"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldError = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = __importDefault(require("styled-components"));
exports.FieldError = styled_components_1.default.div `
  color: ${(props) => props.theme.error};
  border-radius: ${(props) => props.theme.radius};
  grid-column-start: 2;
`;
//# sourceMappingURL=FieldError.js.map